import React, { useState, useEffect } from 'react';
import styles from './Admin.module.css';

const AdminDashboard = ({ token }) => {
    const [stats, setStats] = useState({
        totalUsers: 0,
        verifiedUsers: 0,
        unverifiedUsers: 0,
        pendingUsers: 0,
        recentRegistrations: []
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchDashboardData();
    }, [token]);

    const fetchDashboardData = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://saviol-back-main.onrender.com/admin/dashboard', {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                setStats(data);
            } else {
                setError('Erreur lors de la récupération des statistiques');
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des statistiques:', error);
            setError('Erreur de connexion au serveur');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className={styles.loadingSpinner}>Chargement des statistiques...</div>;
    }

    if (error) {
        return <div className={styles.errorMessage}>{error}</div>;
    }

    return (
        <div className={styles.dashboardContainer}>
            <h2 className={styles.dashboardTitle}>Tableau de bord</h2>

            <div className={styles.statsGrid}>
                <div className={styles.statCard}>
                    <div className={styles.statValue}>{stats.totalUsers}</div>
                    <div className={styles.statLabel}>Utilisateurs totaux</div>
                </div>

                <div className={`${styles.statCard} ${styles.verifiedCard}`}>
                    <div className={styles.statValue}>{stats.verifiedUsers}</div>
                    <div className={styles.statLabel}>Utilisateurs vérifiés</div>
                </div>

                <div className={`${styles.statCard} ${styles.unverifiedCard}`}>
                    <div className={styles.statValue}>{stats.unverifiedUsers}</div>
                    <div className={styles.statLabel}>Utilisateurs non vérifiés</div>
                </div>

                <div className={`${styles.statCard} ${styles.pendingCard}`}>
                    <div className={styles.statValue}>{stats.pendingUsers}</div>
                    <div className={styles.statLabel}>Utilisateurs en attente</div>
                </div>
            </div>

            <div className={styles.recentRegistrations}>
                <h3 className={styles.sectionTitle}>Inscriptions récentes</h3>

                {stats.recentRegistrations.length > 0 ? (
                    <table className={styles.miniTable}>
                        <thead>
                            <tr>
                                <th>Nom</th>
                                <th>Email</th>
                                <th>Date d'inscription</th>
                            </tr>
                        </thead>
                        <tbody>
                            {stats.recentRegistrations.map(user => (
                                <tr key={user.id}>
                                    <td>{user.firstname} {user.lastname}</td>
                                    <td>{user.email}</td>
                                    <td>{new Date(user.created_at).toLocaleDateString('fr-FR')}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <p className={styles.noData}>Aucune inscription récente</p>
                )}
            </div>

            <button
                className={styles.refreshButton}
                onClick={fetchDashboardData}
            >
                Actualiser les données
            </button>
        </div>
    );
};

export default AdminDashboard; 